<template>
    <div id="app-layout" class="">
        <div class="main-container">
            <div class="main-container-wrapper">
                <main-navigation></main-navigation>
                <router-view></router-view>
                <mobile-footer-menu></mobile-footer-menu>
            </div>
        </div>
    </div>
</template>

<script>
import MainNavigation from "./main-navigation.vue";
import MobileFooterMenu from "./mobile-footer-menu.vue";
export default {
    name: "layout",
    components: { MobileFooterMenu, MainNavigation },
    created() {
        console.log("Created Layout");
    },
    created() {
        console.log("Mounted :: Layout");
    }
};
</script>

<style scoped></style>
